import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  computed,
  withDefaults,
  ref,
} from 'vue';
import SwIconButton from '@/components/molecules/Buttons/SwIconButton.vue';

interface Emits {
  (e: 'click'): void;
}
interface Props {
  on?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SwFavoriteButton',
  props: {
    on: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { on: boolean }





const isOn = ref<boolean>(props.on);
const isOnValue = computed({
  get: () => isOn.value,
  set: (value) => {
    isOn.value = value;
  },
});

const color = computed(() => (props.on ? 'pink' : 'gray'));

/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-favorite-button': true,
}));

const onClick = () => {
  emit('click');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_unref(classes))
  }, [
    _createVNode(SwIconButton, {
      label: 123,
      icon: "sw-icon-like",
      color: _unref(color),
      size: "large",
      onClick: onClick
    }, null, 8, ["color"])
  ], 2))
}
}

})